import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bb-solid-blue100 bt-solid-blue100 cart-sort cart-result j-content-center a-i-center text-raleway-14 no-select" }
const _hoisted_2 = { class: "w-100 d-flex j-content-center" }
const _hoisted_3 = { class: "d-flex j-content-center" }
const _hoisted_4 = { class: "text-center" }
const _hoisted_5 = { class: "w-100 d-flex" }
const _hoisted_6 = { class: "d-flex j-content-center" }
const _hoisted_7 = { class: "text-center" }
const _hoisted_8 = { class: "w-100 d-flex j-content-center" }
const _hoisted_9 = { class: "d-flex j-content-center" }
const _hoisted_10 = { class: "text-center" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex direction-column arrow-wrapper j-content-center a-i-center" }, null, -1)
const _hoisted_12 = { class: "w-100 d-flex j-content-center" }
const _hoisted_13 = { class: "d-flex j-content-center" }
const _hoisted_14 = { class: "text-center" }
const _hoisted_15 = { class: "w-100 d-flex j-content-center" }
const _hoisted_16 = { class: "d-flex j-content-center" }
const _hoisted_17 = { class: "text-center" }
const _hoisted_18 = { class: "w-100 d-flex j-content-center" }
const _hoisted_19 = { class: "d-flex j-content-center" }
const _hoisted_20 = { class: "text-center" }
const _hoisted_21 = { class: "w-100 d-flex j-content-center" }
const _hoisted_22 = { class: "d-flex j-content-center" }
const _hoisted_23 = { class: "text-center" }


export default /*#__PURE__*/_defineComponent({
  __name: 'cartSortComponent',
  setup(__props) {

// import { IStore } from "@/store/types/StoreType";
// import { computed, ref } from "vue";
// import { useStore } from "vuex";

// const store = useStore<IStore>();
// // const token = ref(computed<string>(() => store.getters.accessTokenGet));
// // const serverType = ref(computed<string>(() => store.getters.getServerType));
// const filter = ref(computed<string>(() => store.getters.getFilerCart));
// const position = ref("");

// const changeFilter = (key: string) => {
//   if (filter.value === key) position.value = position.value === "" ? "-" : "";
//   else position.value = "";

//   // serverType.value === "retail" && !token.value
//   // ?
//   store.commit("changeSortCart", position.value + key);
//   // : store.dispatch("changeSortCart", position.value + key);
// };

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$tc("Photo")), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$tc("Tyre name")), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$tc("Quantity")), 1),
        _hoisted_11
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.$tc("Price")), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.$tc("Discount")), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_18, [
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.$tc("Total")), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_21, [
      _createElementVNode("div", _hoisted_22, [
        _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.$tc("Total inc. VAT")), 1)
      ])
    ])
  ]))
}
}

})